import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 5px;
`
